import React, { Component } from 'react';
import { Modal, ModalHeader, ModalBody, ModalFooter, Button } from 'reactstrap';
import del from '../../resources/images/estrategas/tools/trash.png';
import * as Request from '../../service/data-info-chart/requestsUtil';
import { DELETE_NEW_BUSINESS } from '../../utils/constants';


class DeleteNewBusiness extends Component{

  constructor(props) {
    super(props);
    this.toggle = this.toggle.bind(this);
    this.state = { modal: false };
  }

  toggle(){
    this.setState({ modal: !this.state.modal })
  }

  deleteNewBusiness(){
    Request.deleteFetch(DELETE_NEW_BUSINESS + this.props.id).then(()=>{
      this.toggle();
      this.props.callbackFromParent(Math.random());
    })
  }

  render() {

    let classUser = this.props.authorization ? 'corrAct-view' : 'quality-edit-unauthorized';

    return (
      <div>
        <Modal size={'lg'} isOpen={this.state.modal} toggle={this.toggle}>
          <ModalHeader className='header-modal'
                       toggle={this.toggle}>Noticias</ModalHeader>
          <ModalBody>
            <h4>¿Esta seguro de que quiere eliminar el negocio "{this.props.title}"?</h4>
          </ModalBody>
          <ModalFooter>
            <Button color="primary" onClick={()=>this.deleteNewBusiness(this.props.id)}>Aceptar</Button>{' '}
            <Button color="danger" onClick={this.toggle}>Cancelar</Button>
          </ModalFooter>
        </Modal>
        <div className={classUser}>
          <img src={del} alt='' onClick={this.toggle}/>
        </div>
      </div>
    );
  }

}

export default DeleteNewBusiness;



// WEBPACK FOOTER //
// ./src/components/buttons/deleteNewBusiness.js